import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { useFlags } from "launchdarkly-react-client-sdk";
import { CALL_BODY_SCREEN, ENABLED } from "../../../../constants/Constants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { isSilentObserverAvailable } from "../../../../shared/function";
import { handleStartStopVideo } from "../../../Twilio/VideoCall/VideoUtils";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { handleStartStopVideoPlaySound } from "../../../Twilio/Room/roomFunction";

const HomeScreenVideoButton = () => {
    const ldFlags = useFlags();
    const localisedValues = useLanguageChange();
    const { isRemoteParticipantJoined, currentCallBodyScreen, isVideoButtonClickDisable } = useSelector((state) => state.commonReducer);
    const { startLocalVideo } = useSelector((state) => state.twilioEvents);

    const videoButtonDisable = useMemo(() => {
        return isRemoteParticipantJoined && PublicVariables.featureFlag?.LIVEVIDEO === ENABLED;
    }, [isRemoteParticipantJoined]);

    const videoBtnAvailable = useCallback(() => {
        return !(GLOBAL_MEETING_DATA.isAgent && ldFlags.hideStartVideoButton === true) && PublicVariables.featureFlag?.LIVEVIDEO === ENABLED;
    }, [ldFlags]);

    const clickOnStartStopVideoHomeButton = () => {
        handleStartStopVideoPlaySound(!startLocalVideo); // handle heptic feedback
        handleStartStopVideo(true); // handle start/stop video
    };

    return (
        <>
            {!isSilentObserverAvailable() && videoBtnAvailable() && (
                <div className='button-out'>
                    <div className='button'>
                        <button
                            className='btn short-btn'
                            data-testid='homeVideoCallBtn'
                            onClick={clickOnStartStopVideoHomeButton}
                            disabled={
                                !videoButtonDisable ||
                                currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN ||
                                !videoBtnAvailable() ||
                                isVideoButtonClickDisable
                            }
                        >
                            <span
                                className={clsx(
                                    "for-icon",
                                    PublicVariables.featureFlag?.LIVEVIDEO === ENABLED && startLocalVideo === true ? "icon-video" : "icon-video-off"
                                )}
                            ></span>
                            <span className='for-text'>
                                {PublicVariables.featureFlag?.LIVEVIDEO === ENABLED && !startLocalVideo
                                    ? localisedValues["start_video"]
                                    : localisedValues["stop_video"]}
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default HomeScreenVideoButton;
